export default "__VITE_ASSET__92b70b7c__"